import {
	AdEngine,
	AdSlotEvent,
	BaseServiceSetup,
	communicationService,
	type AdSlot,
} from '@wikia/ad-engine';

let adEngineInstance: AdEngine;

export class AdEngineStackSetup extends BaseServiceSetup {
	call(): Promise<void> {
		communicationService.onSlotEvent(
			AdSlotEvent.SLOT_RENDERED_EVENT,
			({ slot }: { slot: AdSlot }) => {
				slot.removeClass('default-height');
				this.setUpAdChoicesDisplayPriority(slot);
			},
		);

		adEngineInstance = new AdEngine();
		return adEngineInstance.init();
	}

	private setUpAdChoicesDisplayPriority(adSlot: AdSlot): void {
		const iFrame = adSlot.getIframe();
		const iFrameHasBody = !!iFrame?.contentDocument?.body;

		if (!iFrameHasBody) {
			return;
		}

		const iFrameContainer = iFrame.parentElement;

		const observer = new MutationObserver((mutations) => {
			mutations.forEach(() => {
				if (iFrame?.contentDocument?.body?.classList?.contains('goog_menu_opened')) {
					iFrameContainer?.classList?.add('ad-choices');
				} else {
					iFrameContainer?.classList?.remove('ad-choices');
				}
			});
		});

		observer.observe(iFrame.contentDocument.body, { attributeFilter: ['class'] });
	}
}
